function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.5 19C20 19 23 10.5 23 10.5C23 10.5 20.5 2 11.5 2C2.5 2 0 10.5 0 10.5C0 10.5 3 19 11.5 19ZM11.5 17C15.0898 17 18 14.0898 18 10.5C18 6.91016 15.0898 4 11.5 4C7.91016 4 5 6.91016 5 10.5C5 14.0898 7.91016 17 11.5 17Z",
  fill: "#C4C4C4"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 11.5,
  cy: 10.5,
  r: 3.5,
  fill: "#C4C4C4"
});

var _ref4 = /*#__PURE__*/React.createElement("line", {
  x1: 2.68875,
  y1: 1.275,
  x2: 22.6887,
  y2: 20.275,
  stroke: "#C4C4C4",
  strokeWidth: 2
});

var SvgEye = function SvgEye(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEye, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/eye.073db132.svg";
export { ForwardRef as ReactComponent };